export default __webpack_public_path__ + "static/media/offre-3.b99663b9.png";